(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("GoTop", [], factory);
	else if(typeof exports === 'object')
		exports["GoTop"] = factory();
	else
		root["GoTop"] = factory();
})(window, function() {
return 